module.exports = __webpack_public_path__ + "assets/img/Amaze-Wholesale-1-Landing-Page-w960.11ab9fa8.webp";